/* eslint-disable no-undef */
import Vue from 'vue';
import Vuex from 'vuex';
import VuexPersist from 'vuex-persist';
import * as moment from "moment";

Vue.use(Vuex);

moment.locale('de');
moment.tz.setDefault('Europe/Vienna');

const vuexPersist = new VuexPersist({
  key: 'tour-sol',
  storage: localStorage,
});

export default new Vuex.Store({
  plugins: [vuexPersist.plugin],
  state: {
    language: 'DE',
    minStay: {
      validUntil: undefined,
      blockedFrom: undefined,
      blockedTo: undefined,
      arrival: undefined,
      departure: undefined,
      rules: []
    },
    flags: {
      minStay: false,
    },
    hotel: undefined,
    statistic: {
      occupancy: {
        summary: undefined,
        updated: undefined
      },
      booking: {
        summary: undefined,
        updated: undefined
      }
    }
  },
  mutations: {
    setLanguage(state, language) {
      state.language = language;
    },
    setOccupancySummary(state, newState) {
      state.statistic.occupancy.summary = newState.statistic.occupancy.summary;
      state.statistic.occupancy.updated = moment().endOf('day');
    },
    setBookingSummary(state, newState) {
      state.statistic.booking.summary = newState.statistic.booking.summary;
      state.statistic.booking.updated = moment().endOf('day');
    },
    setHotel(state, newState) {
      state.hotel = newState.hotel;
    },
    setMinStay(state, newState) {
      state.minStay.validUntil = newState.minStay.validUntil;
      state.minStay.blockedFrom = newState.minStay.blockedFrom;
      state.minStay.blockedTo = newState.minStay.blockedTo;
      state.minStay.arrival = newState.minStay.arrival;
      state.minStay.departure = newState.minStay.departure;
      state.minStay.rules = JSON.parse(JSON.stringify(newState.minStay.rules));
      for (let i = 0; i < state.minStay.rules.length; i += 1) {
        state.minStay.rules[i].id = undefined;
      }
      state.flags.minStay = true;
    },
    resetMinStay(state) {
      state.minStay.validUntil = undefined;
      state.minStay.blockedFrom = undefined;
      state.minStay.blockedTo = undefined;
      state.minStay.arrival = undefined;
      state.minStay.departure = undefined;
      state.minStay.rules = [];
      state.flags.minStay = false;
    },
    resetHotel(state) {
      state.hotel = undefined;
    },
    resetStatistics(state) {
      state.statistic.occupancy.summary = undefined;
      state.statistic.occupancy.updated = undefined;
      state.statistic.booking.summary = undefined;
      state.statistic.booking.updated = undefined;
    }
  },
  actions: {
    setLanguage({ commit }, language) {
      commit('setLanguage', language);
    },
    setMinStay({ commit }, minStay) {
      commit('setMinStay', minStay);
    },
    resetMinStay({ commit }) {
      commit('resetMinStay');
    },
    setHotel({ commit }, hotel) {
      commit('setHotel', hotel);
    },
    setOccupancySummary({ commit }, statistic) {
      commit('setOccupancySummary', statistic);
    },
    setBookingSummary({ commit }, statistic) {
      commit('setBookingSummary', statistic);
    },
    resetHotel({ commit }) {
      commit('resetHotel');
    },
    resetStatistics({ commit }) {
      commit('resetStatistics');
    }
  },
  getters: {
    getLanguage: state => state.language,
    hasMinStayCopied: state => state.flags.minStay,
    getMinStay: state => state.minStay,
    getHotel: state => state.hotel,
    getOccupancySummary: state => state.statistic.occupancy,
    getBookingSummary: state => state.statistic.booking,
    hasHotel: state => state.hotel !== undefined
  }
});
